export default __webpack_public_path__ + "static/f5-bd713307151285ccde44aaf8fa47464d.svg";